import React from "react";
import { Row } from "react-bootstrap";
import Card from "react-bootstrap/Card";
import "./RiskInformation.css";
import { HeaderInfoVehicle } from "../HeaderInfo/HeaderInfo";

function RiskInformation(props) {
  const { oportunity } = props;
  const justified = React.useMemo(() => true, []);
  return (
    <>
      <Card body className="mt-3 header-card header-style">
        <Row style={{ width: "100%", margin: 0 }}>
          <HeaderInfoVehicle oportunity={oportunity} justified={justified} />
        </Row>
      </Card>
    </>
  );
}

export { RiskInformation };
